import { render, staticRenderFns } from "./CommunityContent.vue?vue&type=template&id=b8bf4afc&scoped=true&"
import script from "./CommunityContent.vue?vue&type=script&lang=js&"
export * from "./CommunityContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8bf4afc",
  null
  
)

export default component.exports